import React from 'react';

/**
 * WCAG 2.4.1 – Bypass Blocks (Level A)
 * A visually-hidden anchor that becomes visible when focused via keyboard.
 * It must be the first focusable element on the page so that a single Tab
 * from the browser chrome lands here before any nav links.
 */
function SkipToMain() {
  return (
    <a
      href="#main-content"
      className="skip-to-main-content"
      data-test-id="skip-to-main-content"
    >
      Skip to main content
    </a>
  );
}

export default SkipToMain;
